import {Component, EventEmitter, Input, Output, ViewChild, ElementRef, OnInit, OnChanges} from '@angular/core';
import {FormGroup} from '@angular/forms';
import * as moment from 'moment';
import {formLog} from '../../services/debug-logger';

enum DateField {
  Day,
  Month,
  Year
}

@Component({
  standalone: false,
  selector: 'app-data-picker',
  templateUrl: 'data.picker.component.html',
  styleUrls: ['data.picker.component.scss']
})
export class DataPickerComponent implements OnInit, OnChanges {
  public dateFields = DateField;
  @Input() disabled: boolean;
  @Output() disabledChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() label: string;
  @Input() dateYearFormName: string;
  @Input() dateYear: number;
  @Output() dateYearChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() dateDayFormName: string;
  @Input() dateDay: number;
  @Output() dateDayChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() dateMonthFormName: string;
  @Input() dateMonth: number;
  @Output() dateMonthChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() parentForm: FormGroup;
  @Output() dateChanged: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('monthInput') monthInput: ElementRef;
  @ViewChild('yearInput') yearInput: ElementRef;
  days: number[];
  months: number[];
  private selectedDateValue: moment.Moment;

  constructor() {
    this.updateDateValues();
  }

  private _years: number[];

  get years(): number[] {
    return this._years;
  }

  @Input() set years(value: number[]) {
    this._years = value;
  }

  public get selectedDate(): moment.Moment {
    return this.selectedDateValue;
  }

  public set selectedDate(value: moment.Moment) {
    this.selectedDateValue = value;
    this.parseDate(value);
  }

  ngOnInit() {
    this.writeToForm();
  }

  ngOnChanges() {
    this.writeToForm();
  }

  private writeToForm() {
    if (!this.parentForm) {
      return;
    }
    if (this.dateYearFormName) {
      this.parentForm.get(this.dateYearFormName)?.setValue(this.dateYear ?? null, {emitEvent: false});
    }
    if (this.dateMonthFormName) {
      this.parentForm.get(this.dateMonthFormName)?.setValue(this.dateMonth ?? null, {emitEvent: false});
    }
    if (this.dateDayFormName) {
      this.parentForm.get(this.dateDayFormName)?.setValue(this.dateDay ?? null, {emitEvent: false});
    }
    formLog.log('[DataPicker]', this.dateYearFormName, '=', this.dateYear, '/', this.dateMonth, '/', this.dateDay, '| parentForm valid:', this.parentForm && this.parentForm.valid);
  }

  onDateChanged() {
    if (this.parentForm) {
      this.dateYear = this.parentForm.get(this.dateYearFormName)?.value;
      this.dateMonth = this.parentForm.get(this.dateMonthFormName)?.value;
      this.dateDay = this.parentForm.get(this.dateDayFormName)?.value;
    }
    this.dateYearChange.emit(this.dateYear);
    this.dateMonthChange.emit(this.dateMonth);
    this.dateDayChange.emit(this.dateDay);

    this.dateChanged.emit();

    this.updateDateValues();
    formLog.log('[DataPicker]', this.dateYearFormName, '=', this.dateYear, '/', this.dateMonth, '/', this.dateDay, '| parentForm valid:', this.parentForm && this.parentForm.valid);
  }

  parseDate(date: moment.Moment) {
    if (date.isValid()) {
      const nativeDate = date.toDate();
      this.dateYear = nativeDate.getFullYear();
      this.dateMonth = (nativeDate.getMonth() + 1);
      this.dateDay = nativeDate.getDate();
      this.writeToForm();
      this.onDateChanged();
    }
  }

  getDays() {
    if (this.dateMonth === 2) {
      if ((this.dateYear % 4 === 0 &&
          this.dateYear % 100 !== 0) ||
        (this.dateYear % 400 === 0)) {
        return 29;
      } else {
        return 28;
      }
    } else if (this.dateMonth === 4 ||
      this.dateMonth === 6 ||
      this.dateMonth === 9 ||
      this.dateMonth === 11) {
      return 30;
    } else {
      return 31;
    }
  }

  private updateDateValues() {

    this.days = Array(this.getDays()).fill(0).map((x, i) => i + 1);

    this.months = Array(12).fill(0).map((x, i) => i + 1);

    if (!this._years || this._years.length === 0) {
      const currentYear = new Date().getFullYear() - 17;
      this.years = Array(100).fill(0).map((x, i) => currentYear - i);
    }
  }
}
